import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/authenticate/welcome-set-password")({
  component: lazyImportRouteComponent(
    () => import("./-components/SetPassword"),
    "SetPassword"
  ),
  validateSearch: (search: {
    token: string
    userId: number
    userName: string
  }) => search,
})
